import React from 'react';
import { Dialog } from '@/shared/components/Dialog';
import {
  Card,
  CardBody,
  CardContent,
  CardStyle,
} from '@/shared/components/Card';
import { Button } from '@/shared/components/Buttons';
import { ButtonVariant } from '@/shared/components/Buttons/types';
import ProfileModalIcon from '@/assets/svg/profileModal.svg';

// ============================================================================
// Component
// ============================================================================

interface CompleteProfileModalProps {
  open: boolean;
  onSkip: () => void;
  onConfigure: () => void;
}

const CompleteProfileModal: React.FC<CompleteProfileModalProps> = ({
  open,
  onSkip,
  onConfigure,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onSkip}
      maxWidth={432}
      data-testid="complete-profile-modal"
    >
      <Card style={CardStyle.Elevated} width={432}>
        <CardBody padding="large">
          <div className="flex flex-col items-center gap-6 text-center w-full min-w-0">
            <div className="flex items-center justify-center w-[137px] h-[137px] shrink-0">
              <ProfileModalIcon />
            </div>

            <CardContent
              title={'\u0055zupe\u0142nij profil'}
              className="!px-0 !py-0 flex flex-col items-center !gap-4 !text-[#474A4C] [&>p]:!font-normal w-full min-w-0 max-w-full"
            >
              <p
                className="text-center w-full min-w-0 break-words"
                style={{
                  fontSize: 14,
                  lineHeight: '20px',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                }}
              >
                {
                  'Skonfiguruj profil, aby korzysta\u0107 ze spersonalizowanego i p\u0142ynnego dzia\u0142ania aplikacji.'
                }
              </p>
            </CardContent>

            <div className="flex flex-row items-center justify-center w-full gap-3 px-5">
              <Button
                label={'Pomi\u0144 na razie'}
                onClick={onSkip}
                customFontWeight={500}
                className={`!bg-transparent !h-[40px] !rounded-[8px] border !border-[#DCDDE0] !text-labelLarge !text-on-surface-variant hover:!bg-neutral-95 hover:border-neutral-70 w-full  cursor-pointer`}
              />
              <Button
                label="Skonfiguruj profil"
                variant={ButtonVariant.Primary}
                onClick={onConfigure}
                customFontWeight={500}
                className="!h-[40px] !rounded-[8px] !text-labelLarge !text-white w-full cursor-pointer"
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Dialog>
  );
};

export default CompleteProfileModal;
